import { FC } from 'react';
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Tables/Table/Table';
import styles from './StorePricesModal.module.css';
import { StorePricesModalProps } from './StorePricesModal.types';

import { useBundleStoresCount } from '@/services/bundles/bundles.service';
import { Grid, Typography } from '@mui/material';
import Button from '@/components/Button/Button';
import { useTranslation } from 'react-i18next';

const StorePricesModal: FC<StorePricesModalProps> = ({ isOpen, onClose, bundleId, pricePoint = '' }) => {
  const numericPricePoint = pricePoint.replace('$', '');
  const { data: bundleStoreCount } = useBundleStoresCount({
    bundleId,
    enabled: !!pricePoint && !!bundleId,
    pricePoint: numericPricePoint,
  });
  const { t } = useTranslation();
  const bundleCodeLabel = t('storeListModal.bundleCodeLabel');
  const priceLabel = t('storeListModal.priceLabel');
  const noOfStoresLabel = t('storeListModal.noOfStoresLabel');

  const storeData = bundleStoreCount?.stores?.sort((a, b) => parseInt(a.storeNo, 10) - parseInt(b.storeNo, 10)) || [];
  return (
    <Modal
      className={styles.moveStores}
      isOpen={isOpen}
      onClose={onClose}
      headerContent="Store List"
      data-testid="Modal"
      showTitleDivider
      bodyClass={styles.tableContainer}
      bodyContent={
        <div className={styles.body}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            fontSize={24}
            paddingX={3}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'Open Sans',
                  fontWeight: '700',
                  paddingTop: 2,
                  paddingBottom: 2,
                  fontSize: ' 1.8rem',
                }}
              >
                {bundleCodeLabel}: <span style={{ fontWeight: 'normal' }}>{bundleStoreCount?.bundleCode}</span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'Open Sans',
                  fontWeight: '700',
                  paddingTop: 2,
                  paddingBottom: 2,
                  fontSize: ' 1.8rem',
                }}
              >
                {priceLabel}:{' '}
                <span style={{ fontWeight: 'normal' }}>${Number(bundleStoreCount?.pricePoint || 0).toFixed(2)}</span>
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'Open Sans',
                  fontWeight: '700',
                  paddingTop: 2,
                  paddingBottom: 2,
                  fontSize: ' 1.8rem',
                }}
              >
                {noOfStoresLabel}: <span style={{ fontWeight: 'normal' }}>{bundleStoreCount?.totalStores}</span>
              </Typography>
            </Grid>
          </Grid>
          <Table
            includeMinWidth={false}
            height="40vh"
            data={storeData}
            columns={[
              { header: 'Store #', accessorKey: 'storeNo', enableSorting: true },
              { header: 'ORG', accessorKey: 'fzCode', enableSorting: true },
            ]}
            enableFilters
            className="scrool"
          />
        </div>
      }
      footerContent={
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Button
            data-testid="storePricesModalClose"
            style={{ width: '240px', justifyContent: 'center', marginTop: '' }}
            onClick={() => onClose()}
          >
            Close
          </Button>
        </div>
      }
    />
  );
};

export default StorePricesModal;
